import {put, takeLatest, call} from 'redux-saga/effects';
import {SUCCESS_KEY} from 'constants/keys';

import {
  getProfileDetailsRequest,
  getProfileDetailsSuccess,
  getProfileDetailsFailure,
  getProfileDetailsSuccessResponse,
  updateProfileDetailsRequest,
  updateProfileDetailsSuccess,
  updateProfileDetailsFailure,
  updateProfileDetailsParams,
  updateProfileDetailsResponse,
} from 'redux/slices/myProfileSlice';

import {setProfilePhotoUrl} from 'redux/slices/authSlice';

import {
  getProfile as getProfileAPI,
  updateProfile as updateProfileAPI,
} from 'services/api';

type GetProfileDetailsResponse = {
  status: string;
} & getProfileDetailsSuccessResponse;

type UpdateProfileDetailsAction = {
  type: typeof updateProfileDetailsRequest.type;
  payload: updateProfileDetailsParams;
};

type UpdateProfileDetailsResponse = {
  status: string;
} & updateProfileDetailsResponse;

/**
 * function to get profile details
 */
function* getProfile(): Generator {
  try {
    const response: GetProfileDetailsResponse = yield call(getProfileAPI);
    if (response.status === SUCCESS_KEY) {
      yield put(getProfileDetailsSuccess(response));
    } else {
      yield put(getProfileDetailsFailure(response.status_code));
    }
  } catch (error) {
    yield put(getProfileDetailsFailure('E-10001'));
  }
}

/**
 * function to update profile details
 */
function* updateProfile(action: UpdateProfileDetailsAction): Generator {
  try {
    const response: UpdateProfileDetailsResponse = yield call(
      updateProfileAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(updateProfileDetailsSuccess(response));
      yield put(setProfilePhotoUrl(response?.data?.profile ?? ''));
    } else {
      yield put(updateProfileDetailsFailure(response.status_code));
    }
  } catch (error) {
    yield put(updateProfileDetailsFailure('E-10001'));
  }
}

export function* profileSaga() {
  yield takeLatest(getProfileDetailsRequest.type, getProfile);
  yield takeLatest(updateProfileDetailsRequest.type, updateProfile);
}
